module.exports = __webpack_public_path__ + "fonts/SFProText-Regular.c7e2854d.woff2";